import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import apiService from '../../services/apiService'

function TermsAndConditionsPage() {
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      try {
        setLoading(true);
        const response = await apiService.get('/terms-and-conditions');
        setTerms(response);
      } catch (err) {
        console.error('Fetch terms and conditions error:', err);
        setError(err.response?.data?.error || 'Failed to load terms and conditions');
        toast.error('Failed to load terms and conditions');
      } finally {
        setLoading(false);
      }
    };

    fetchTermsAndConditions();
  }, []);

  if (loading) {
    return <div className="text-center text-gray-600 dark:text-gray-300">Loading terms and conditions...</div>;
  }

  if (error) {
    return <div className="text-center text-red-600 dark:text-red-400">Error: {error}</div>;
  }

  if (!terms) {
    return <div className="text-center text-gray-600 dark:text-gray-300">No terms and conditions available.</div>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md">
      <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-6">{terms.title}</h1>
      <div 
        className="prose dark:prose-invert max-w-none"
        dangerouslySetInnerHTML={{ __html: terms.content }}
      />
      <p className="mt-6 text-sm text-gray-500 dark:text-gray-400">
        Last updated: {new Date(terms.updatedAt).toLocaleDateString()}
      </p>
    </div>
  );
}

export default TermsAndConditionsPage;